import type { PRMToolBarProps } from './PRMToolBarTypes';
import './PRMToolBar.scss';

const PRMToolBar = ({ toolBarStart, toolBarEnd }: PRMToolBarProps) => {
  if (!toolBarStart && !toolBarEnd) return null;

  return (
    <div className="prmToolBar">
      {toolBarStart && <div className="prmToolBar-start">{toolBarStart}</div>}
      {toolBarEnd && <div className="prmToolBar-end">{toolBarEnd}</div>}
    </div>
  );
};

export default PRMToolBar;
